/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { Button, Icon } from 'semantic-ui-react'
import { useTranslation } from 'react-i18next'
import { useMutation } from '@tanstack/react-query'
import { exportUnavailableItems } from '../../../services/Item/Item.service'
import { useSearchParams } from 'react-router-dom-v5-compat'
import { saveFile } from '../../../services/File/File.service'

const ExportButton = ({ unavailableItems }) => {
    const [t] = useTranslation()
    const [searchParams] = useSearchParams()

    const from = searchParams.get('from')
    const to = searchParams.get('to')

    const exportUnavailableItemsMutation = useMutation({
        mutationFn: () => exportUnavailableItems(from, to),
        onSuccess: (data) => {
            saveFile(t('unavailable_items.export_file_name'), data, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
        }
    })

    return (
      <Button
        css={css`
            &.ui.button {
                margin-top: .5rem;
            }
        `}
        icon
        disabled={!unavailableItems || unavailableItems.length === 0}
        loading={exportUnavailableItemsMutation.isPending}
        onClick={exportUnavailableItemsMutation.mutate}
      >
          <Icon name="cloud download"/>
      </Button>
    )
}

export { ExportButton }
